import { SET_KNOWN_FILES } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').KnownFilesEntry} KnownFile
 */

/**
 * @typedef {ReturnType<typeof setKnownFiles>} KnownFilesActions
 */

/**
 * @param {Array<KnownFile>} knownFiles
 * @return {{ type: 'SET_KNOWN_FILES', knownFiles: Array<KnownFile> }}
 */
export const setKnownFiles = (knownFiles) => ({
  type: SET_KNOWN_FILES,
  knownFiles,
})
